module.exports = __webpack_public_path__ + "img/chofu_favorite_on.3deb02de.svg";